<script setup lang="ts">
import { BriefcaseBusiness, MapPin } from 'lucide-vue-next'

// Stack of vacancy cards, the top one ready for a reply
const { t } = useI18n()
</script>

<template>
  <div class="relative w-[21rem] select-none pt-8" aria-hidden="true">
    <div class="absolute inset-x-10 top-0 rounded-2xl bg-white/70 px-4 py-2 text-sm font-semibold text-gray-400 ring-1 ring-blue-100">
      {{ t('widget.hero_banner.illustration.vacancies.analyst') }}
    </div>
    <div class="absolute inset-x-5 top-4 rounded-2xl bg-white/90 px-4 py-2 text-sm font-semibold text-gray-500 ring-1 ring-blue-100">
      {{ t('widget.hero_banner.illustration.vacancies.cashier') }}
    </div>

    <div class="HeroIllustrationCard">
      <div class="flex items-start gap-3">
        <span class="grid size-11 shrink-0 place-items-center rounded-xl bg-blue-600 text-white">
          <BriefcaseBusiness class="size-5" />
        </span>
        <div>
          <div class="font-serif text-xl font-bold leading-tight">{{ t('widget.hero_banner.illustration.vacancies.position') }}</div>
          <div class="mt-1 flex items-center gap-1 text-sm text-gray-500">
            <MapPin class="size-3.5" />
            {{ t('widget.hero_banner.illustration.vacancies.city') }}
          </div>
        </div>
      </div>

      <div class="mt-3 flex flex-wrap gap-1.5">
        <span class="rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold">{{ t('widget.hero_banner.illustration.vacancies.full_time') }}</span>
        <span class="rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold">{{ t('widget.hero_banner.illustration.vacancies.office') }}</span>
      </div>

      <div class="mt-4 rounded-lg bg-blue-600 py-2 text-center text-sm font-semibold text-white">
        {{ t('widget.hero_banner.illustration.vacancies.apply') }}
      </div>
    </div>

    <div class="HeroIllustrationSticker -right-6 top-14 text-sm font-semibold">
      {{ t('widget.hero_banner.illustration.vacancies.new') }}
    </div>
  </div>
</template>
